// New AppointmentListService.js (similar to AppointmentListService.js but adapted for the patient project)

import axiosInstance from '../../api/auth/axiosInstance';
import Swal from 'sweetalert2';
export const AppointmentListService = {
    fetchAppointmentsByCompany: async (comId, page = 0, size = 10) => {
    try {
      const response = await axiosInstance.get(`/appointment-list/company/${comId}`, {
        params: { page, size },
        headers: { authType: "PostLogin"}
        
      });
      return response;
    } catch (error) {
      console.error("Error fetching appointments:", error);
      window.alert("Error fetching appointments: " + (error.response?.data?.statusDescription || error.message));
      throw error;
    }
  },

  fetchAppointmentsByDateForPending: async (fromDate,toDate,id,type, page = 0, size = 10) => {
    try {
      const response = await axiosInstance.get(`/appointment-list/date-filter/pending?fromDate=${fromDate}&toDate=${toDate}`, {
        params: {id,type, page, size },
        headers: { authType: "PostLogin"}
      });
      return response;
    } catch (error) {
      console.error("Error fetching appointments:", error);
      Swal.fire({
                                                                              icon: "error",
                                                                              title: "Failed!",
                                                                              text: "Error fetching appointments: " + (error.response?.data?.statusDescription || error.message),
                                                                            });
      
      throw error;
    }
  },
   fetchAppointmentsByDateForCompleted: async (fromDate,toDate,id,type, page = 0, size = 10) => {
    try {
      const response = await axiosInstance.get(`/appointment-list/date-filter/completed?fromDate=${fromDate}&toDate=${toDate}`, {
        params: {id,type, page, size },
        headers: { authType: "PostLogin"}
      });
      return response;
    } catch (error) {
      console.error("Error fetching appointments:", error);
      Swal.fire({
                                                                              icon: "error",
                                                                              title: "Failed!",
                                                                              text: "Error fetching appointments: " + (error.response?.data?.statusDescription || error.message),
                                                                            });
      
      throw error;
    }
  },

fetchAppointmentsByDateForSeen: async (fromDate,toDate,id,type, page = 0, size = 10) => {
    try {
      const response = await axiosInstance.get(`/appointment-list/date-filter/seen?fromDate=${fromDate}&toDate=${toDate}`, {
        params: {id,type, page, size },
        headers: { authType: "PostLogin"}
      });
      return response;
    } catch (error) {
      console.error("Error fetching appointments:", error);
      Swal.fire({
                                                                              icon: "error",
                                                                              title: "Failed!",
                                                                              text: "Error fetching appointments: " + (error.response?.data?.statusDescription || error.message),
                                                                            });
      
      throw error;
    }
  },

  fetchAppointmentsByDateForMissing: async (fromDate,toDate,id,type, page = 0, size = 10) => {
    try {
      const response = await axiosInstance.get(`/appointment-list/date-filter/miss?fromDate=${fromDate}&toDate=${toDate}`, {
        params: {id,type, page, size },
        headers: { authType: "PostLogin"}
      });
      return response;
    } catch (error) {
      console.error("Error fetching appointments:", error);
      Swal.fire({
                                                                              icon: "error",
                                                                              title: "Failed!",
                                                                              text: "Error fetching appointments: " + (error.response?.data?.statusDescription || error.message),
                                                                            });
      
      throw error;
    }
  },

  // New for declined
  fetchAppointmentsByDateForDeclined: async (fromDate,toDate,id,type, page = 0, size = 10) => {
    try {
      const response = await axiosInstance.get(`/appointment-list/date-filter/declined?fromDate=${fromDate}&toDate=${toDate}`, {
        params: {id,type, page, size },
        headers: { authType: "PostLogin"}
      });
      return response;
    } catch (error) {
      console.error("Error fetching appointments:", error);
      Swal.fire({
                                                                              icon: "error",
                                                                              title: "Failed!",
                                                                              text: "Error fetching appointments: " + (error.response?.data?.statusDescription || error.message),
                                                                            });
      
      throw error;
    }
  },

  fetchAppointmentsByPatients: async (patId) => {
    try {
      const response = await axiosInstance.get(`/appointment-list/patient-id/${patId}`,{
        headers: { authType: "PostLogin"}
      });
      return response;
    } catch (error) {
      console.error("Error fetching patients:", error);
      window.alert("Error fetching patients: " + (error.response?.data?.statusDescription || error.message));
      throw error;
    }
  },

  fetchAppointmentsByUsers: async (usersId, page = 0, size = 10) => {
    try {
      const response = await axiosInstance.get(`/appointment-list/${usersId}`, {
        params: { page, size },
        headers: { authType: "PostLogin"}
      });
      return response;
    } catch (error) {
      console.error("Error fetching appointments:", error);
      window.alert("Error fetching appointments: " + (error.response?.data?.statusDescription || error.message));
      throw error;
    }
  },
  getAppointmentsBySearchTermPending: async (searchTerm,fromDate,toDate,id,type, page = 0, size = 10) => {
    try {
      const response = await axiosInstance.get(`/appointment-list/search-term/pending/${searchTerm}?fromDate=${fromDate}&toDate=${toDate}`, {
        params: {id,type, page, size },
        headers: { authType: "PostLogin"}
      });
      return response;
    } catch (error) {
      console.error("Error fetching appointments:", error);
      window.alert("Error fetching appointments: " + (error.response?.data?.statusDescription || error.message));
      throw error;
    }
  },
  getAppointmentsBySearchTermCompleted: async (searchTerm,fromDate,toDate,id,type, page = 0, size = 10) => {
    try {
      const response = await axiosInstance.get(`/appointment-list/search-term/completed/${searchTerm}?fromDate=${fromDate}&toDate=${toDate}`, {
        params: {id,type, page, size },
        headers: { authType: "PostLogin"}
      });
      return response;
    } catch (error) {
      console.error("Error fetching appointments:", error);
      window.alert("Error fetching appointments: " + (error.response?.data?.statusDescription || error.message));
      throw error;
    }
  },
    getAppointmentsBySearchTermSeen: async (searchTerm,fromDate,toDate,id,type, page = 0, size = 10) => {
    try {
      const response = await axiosInstance.get(`/appointment-list/search-term/done/${searchTerm}?fromDate=${fromDate}&toDate=${toDate}`, {
        params: {id,type, page, size },
        headers: { authType: "PostLogin"}
      });
      return response;
    } catch (error) {
      console.error("Error fetching appointments:", error);
      window.alert("Error fetching appointments: " + (error.response?.data?.statusDescription || error.message));
      throw error;
    }
  },
  getAppointmentsBySearchTermMissing: async (searchTerm,fromDate,toDate,id,type, page = 0, size = 10) => {
    try {
      const response = await axiosInstance.get(`/appointment-list/search-term/missing/${searchTerm}?fromDate=${fromDate}&toDate=${toDate}`, {
        params: {id,type, page, size },
        headers: { authType: "PostLogin"}
      });
      return response;
    } catch (error) {
      console.error("Error fetching appointments:", error);
      window.alert("Error fetching appointments: " + (error.response?.data?.statusDescription || error.message));
      throw error;
    }
  },

  // New for declined
  getAppointmentsBySearchTermDeclined: async (searchTerm,fromDate,toDate,id,type, page = 0, size = 10) => {
    try {
      const response = await axiosInstance.get(`/appointment-list/search-term/declined/${searchTerm}?fromDate=${fromDate}&toDate=${toDate}`, {
        params: {id,type, page, size },
        headers: { authType: "PostLogin"}
      });
      return response;
    } catch (error) {
      console.error("Error fetching appointments:", error);
      window.alert("Error fetching appointments: " + (error.response?.data?.statusDescription || error.message));
      throw error;
    }
  },
   insertVisitngsWithApt: async (aptData) => {
    try {
      const response = await axiosInstance.post(`/visits/with-apt-data/`, aptData,{
        headers: { authType: "PostLogin"}
      });
    
      console.warn(response.data.data);
      return response.data.data;
    } catch (error) {
      console.error("Error inserting visiting:", error);
      window.alert("Error inserting visiting: " + (error.response?.data?.statusDescription || error.message));
      throw error;
    }
  },
  deleteAppointmentById: async (id,payLoad) => {
    try {
      const response = await axiosInstance.delete(`/appointment-list/delete/${id}`,{
    headers: { authType: "PostLogin" },
    data: payLoad // ✅ request body
  });
    
      console.warn(response.data.data);
      return response.data.data;
    } catch (error) {
      console.error("Error deleting appointment:", error);
      window.alert("Error deleting appointment: " + (error.response?.data?.statusDescription || error.message));
      throw error;
    }
  },
  // New method for changing status
  changeAppointmentStatus: async (apptId, status, through, updatedBy) => {
    try {
      const payLoad = { status, through, updatedBy };
      const response = await axiosInstance.put(`/appointment-list/change-status/${apptId}`, payLoad, {
        headers: { authType: "PostLogin" }
      });
      return response.data;
    } catch (error) {
      console.error("Error changing status:", error);
      Swal.fire({
        icon: "error",
        title: "Failed!",
        text: "Error changing status: " + (error.response?.data?.statusDescription || error.message),
      });
      throw error;
    }
  },

  fetchAppointmentsByDateForAll: async (fromDate, toDate, id, type, page = 0, size = 10) => {
  try {
    const response = await axiosInstance.get(`/appointment-list/date-filter/all?fromDate=${fromDate}&toDate=${toDate}`, {
      params: { id, type, page, size },
      headers: { authType: "PostLogin" }
    });
    return response;
  } catch (error) {
    console.error("Error fetching appointments:", error);
    Swal.fire({
      icon: "error",
      title: "Failed!",
      text: "Error fetching appointments: " + (error.response?.data?.statusDescription || error.message),
    });
    throw error;
  }
},
getInvoiceByDate: async (fromDate,toDate,patientId, page = 0, size = 10) => {
    try {
      const response = await axiosInstance.get(`/create-invoice/by-date/through-patient/${patientId}?fromDate=${fromDate}&toDate=${toDate}`,
         {
          params: { page, size },
        headers: {
          authType: "PostLogin"
      } }
     );
      return response;
    } catch (error) {
      console.error("Error fetching invoice details:", error);
      Swal.fire({
  title: 'Failed!',
  text: `Error fetching invoice details: ${(error.response?.data?.statusDescription || error.message)}`,
  icon: 'error',
  confirmButtonColor: '#566fe2', // your custom button color
  customClass: {
    title: 'swal-title-small',
    popup: 'swal-popup-small',
    confirmButton: 'swal-button-small'
  }
});
      throw error;
    }
  },
 getInvoiceByInvoiceId: async (invoiceId) => {
    try {
      const response = await axiosInstance.get(`/create-invoice/invoice-id/${invoiceId}`, {
        headers: {
          authType: "PostLogin"
      } });
      return response;
    } catch (error) {
      console.error("Error fetching invoice details:", error);
      Swal.fire({
  title: 'Failed!',
  text: `Error fetching invoice details: ${(error.response?.data?.statusDescription || error.message)}`,
  icon: 'error',
  confirmButtonColor: '#566fe2', // your custom button color
  customClass: {
    title: 'swal-title-small',
    popup: 'swal-popup-small',
    confirmButton: 'swal-button-small'
  }
});
      throw error;
    }
  },

   getPatientByCreatedById: async (createdBy) => {
    try {
      const response = await axiosInstance.get(`/patients/patient-created-by/${createdBy}`, {
        headers: {
          authType: "PostLogin"
      } });
      return response;
    } catch (error) {
      console.error("Error fetching patient details:", error);
      Swal.fire({
  title: 'Failed!',
  text: `Error fetching invoice details: ${(error.response?.data?.statusDescription || error.message)}`,
  icon: 'error',
  confirmButtonColor: '#566fe2', // your custom button color
  customClass: {
    title: 'swal-title-small',
    popup: 'swal-popup-small',
    confirmButton: 'swal-button-small'
  }
});
      throw error;
    }
  },

  getPatientByPatientId: async (patientId) => {
    try {
      const response = await axiosInstance.get(`/patients/patient-id/${patientId}`, {
        headers: {
          authType: "PostLogin"
      } });
      return response;
    } catch (error) {
      console.error("Error fetching patient details:", error);
      Swal.fire({
  title: 'Failed!',
  text: `Error fetching invoice details: ${(error.response?.data?.statusDescription || error.message)}`,
  icon: 'error',
  confirmButtonColor: '#566fe2', // your custom button color
  customClass: {
    title: 'swal-title-small',
    popup: 'swal-popup-small',
    confirmButton: 'swal-button-small'
  }
});
      throw error;
    }
  },
  changePatientDetails: async (patientId,payLoad) => {
    try {
      
      const response = await axiosInstance.put(`/patients/patient-update/${patientId}`, payLoad, {
        headers: { authType: "PostLogin" }
      });
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Changes done: " + response.data.data,
      });
      return response.data;
    } catch (error) {
      console.error("Error changing details:", error);
      Swal.fire({
        icon: "error",
        title: "Failed!",
        text: "Error changing status: " + (error.response?.data?.statusDescription || error.message),
      });
      throw error;
    }
  },
};

export default AppointmentListService;